// ─── Environment + constants ────────────────────────────────────────────────
// EXPO_PUBLIC_* vars are injected at build time via Vite's `define` fallback OR
// the standard import.meta.env (VITE_ prefix). We accept both so the same names
// as the native app work in the host build env. All are PUBLIC keys.

function env(name: string): string {
  const e = import.meta.env as Record<string, string | undefined>;
  return e[name] ?? e[`VITE_${name.replace(/^EXPO_PUBLIC_/, '')}`] ?? '';
}

export const SUPABASE_URL = env('EXPO_PUBLIC_SUPABASE_URL');
export const SUPABASE_ANON_KEY = env('EXPO_PUBLIC_SUPABASE_ANON_KEY');
export const POSTHOG_KEY = env('EXPO_PUBLIC_POSTHOG_KEY');
// The SortBeat PostHog project is on EU cloud — the key is rejected by the US
// ingestion host. Keep this default in sync with EXPO_PUBLIC_POSTHOG_HOST.
export const POSTHOG_HOST = env('EXPO_PUBLIC_POSTHOG_HOST') || 'https://eu.i.posthog.com';

// The web v0 uses only the free default track. BPM must match audioSkins.ts's
// "Puzzle Rush" entry (120). The audio file is served from /public (not bundled).
export const DEFAULT_BPM = 120;
export const MUSIC_URL = '/audio/puzzle-rush.mp3';
export const ACCENT = '#6C63FF';

// Falling-token speed. Native (src/ui/GameBoard.tsx) uses 120 px/s, but on a
// near-empty board that's a ~6 s fall which reads as sluggish/unresponsive on
// web; 150 keeps the opening calm without the dead air. Hard-drop is the real
// timing lever regardless.
export const ITEM_SPEED = 150; // px/s at baseline
export const DIFFICULTY_RAMP_MS = 90_000; // reach 2x after 90s
export const DIFFICULTY_MAX_MULTIPLIER = 2.5;
export const ON_BEAT_WINDOW_MS = 50;

export const SITE_URL = 'https://sortbeat.app';
